var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
export var Persone = function Persone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 7.722C8.25 9.809 9.929 11.5 12 11.5c2.071 0 3.75-1.691 3.75-3.778v-.944C15.75 4.691 14.071 3 12 3 9.929 3 8.25 4.691 8.25 6.778v.944zM4 17.5c0-2.66 5.33-4 8-4s8 1.34 8 4v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2z",
    fill: "currentColor"
  })));
};